import * as yup from "yup";

export const reportTypeSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
  description: yup.string().label("Description"),
  url: yup.string().required().label("URL"),
});
